// AGC: Admin toggle switch — on/off with brand-primary track
import React from 'react'

interface AdminToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  disabled?: boolean
  className?: string
}

export const AdminToggle: React.FC<AdminToggleProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  className = '',
}) => (
  <label className={`inline-flex items-center gap-3 cursor-pointer select-none ${disabled ? 'opacity-50 pointer-events-none' : ''} ${className}`}>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      disabled={disabled}
      className={`
        relative inline-flex h-[22px] w-[40px] shrink-0 rounded-full transition-colors duration-200
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary dark:focus-visible:ring-brand-light
        ${checked
          ? 'bg-brand-primary dark:bg-brand-light'
          : 'bg-slate-300 dark:bg-slate-600'
        }
      `.replace(/\s+/g, ' ').trim()}
    >
      <span
        className={`
          pointer-events-none inline-block h-[18px] w-[18px] rounded-full bg-white shadow-sm
          transition-transform duration-200
          ${checked ? 'translate-x-[20px]' : 'translate-x-[2px]'}
          mt-[2px]
        `.replace(/\s+/g, ' ').trim()}
      />
    </button>
    {label && (
      <span className="text-sm text-slate-700 dark:text-slate-300">{label}</span>
    )}
  </label>
)
